import styled from 'styled-components';
import { ContainerGrayBottomBorder } from '../QuestionRow/QuestionRow.styled';
import { COLORS } from 'assets/styled/colors';

// Extended rather than styled inline so the margin stays off the shared question
// row container, which every QuestionRow also renders.
export const TemplateRowContainer = styled(ContainerGrayBottomBorder)`
  padding-bottom: 10rem;
  border-bottom: 1px solid ${COLORS.BORDER};
`;
